import React from 'react';
import ChangeModifierPositionState from './changeModifierPositionState/ChangeModifierPositionState';
import ChangeModifierPosition from './components/ChangeModifierPosition/ChangeModifierPosition';

const ChangeModifierPositionPage: React.FC = () => {
	return (
		<ChangeModifierPositionState>
			<ChangeModifierPosition />
		</ChangeModifierPositionState>
	);
};

export default ChangeModifierPositionPage;
